<template>
  <div class="base-control-container">
    <BaseControlWrapper v-bind="$props">
      <template v-slot:header="{ label }">
        <slot name="header" :label="label" />
      </template>
      <template v-slot:form-control="{}">
        <v-checkbox
          :id="id"
          :ref="id"
          :input-value="$attrs.value"
          :data-ruid="`input-${id}`"
          :label="checkboxText"
          :true-value="true"
          :false-value="false"
          class="base-control-container-checkbox"
          dense
          flat
          solo
          hide-details
          :disabled="disabled"
          :readonly="disabled"
          :append-icon="$attrs['append-icon']"
          @change="$emit('updateIndeterminate', $event)"
          @click:append="$emit('clickAppend', $event)"
        ></v-checkbox>
      </template>
      <template v-slot:errors="{ errors }">
        <slot name="errors" :errors="errors" />
      </template>
      <template v-slot:footer>
        <slot name="footer" />
      </template>
      <template v-slot:help>
        <slot name="help" />
      </template>
    </BaseControlWrapper>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import BaseFormControl from "../../helpers/BaseFormControl";
import BaseControlWrapper from "./BaseControlWrapper.vue";

@Component({
  name: "BaseCheckbox",
  components: {
    BaseControlWrapper,
  },
})
export default class BaseCheckbox extends BaseFormControl {
  @Prop({ default: null }) readonly checkboxText!: string;

  created(): void {
    super.created();
  }
}
</script>
